


// import axios from 'axios';

// const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8080/api';

// const api = axios.create({
//   baseURL: API_BASE_URL,
// });

// api.interceptors.request.use((config) => {
//   const token = localStorage.getItem('sow_token');
//   if (token) {
//     config.headers.Authorization = `Bearer ${token}`;
//   }
//   return config;
// });

// api.interceptors.response.use(
//   (response) => response,
//   (error) => {
//     if (error.response && error.response.status === 401) {
//       localStorage.removeItem('sow_token');
//       localStorage.removeItem('sow_user');
//       if (window.location.pathname.startsWith('/member') || window.location.pathname.startsWith('/admin')) {
//         window.location.href = '/login';
//       }
//     }
//     return Promise.reject(error);
//   }
// );

// // ---- Auth ----
// export const registerMember = (data) => api.post('/auth/register', data);
// export const registerAdmin = (data) => api.post('/auth/register-admin', data);
// export const loginUser = (data) => api.post('/auth/login', data);
// export const forgotPassword = (email) => api.post('/auth/forgot-password', { email });
// export const resetPassword = (token, newPassword) => api.post('/auth/reset-password', { token, newPassword });

// // ---- Member ----
// export const getMyProfile = () => api.get('/member/profile');
// export const getMyCases = () => api.get('/member/cases');
// export const getCaseTimeline = (caseId) => api.get(`/member/cases/${caseId}/timeline`);
// export const createCase = (data) => api.post('/cases', data);
// export const getMyDocuments = () => api.get('/member/documents');
// export const uploadDocument = (formData) =>
//   api.post('/member/documents/upload', formData, { headers: { 'Content-Type': 'multipart/form-data' } });
// export const getMyMessages = () => api.get('/member/messages');
// export const sendMessage = (content) => api.post('/member/messages', { content });
// export const getMyAppointments = () => api.get('/member/appointments');
// export const bookAppointment = (data) => api.post('/member/appointments', data);
// export const getMyReferrals = () => api.get('/member/referrals');

// // ---- Public ----
// export const getPublicStats = () => api.get('/public/stats');
// export const getContentByCategory = (category) => api.get(`/public/content/${category}`);
// export const getMembershipPackages = () => api.get('/public/membership-packages');
// export const applyAsVolunteer = (data) => api.post('/public/volunteer', data);
// export const submitEmployerComplaint = (data) => api.post('/public/employer-complaint', data);
// export const submitContactMessage = (data) => api.post('/public/contact', data);

// // ---- Admin ----
// export const adminGetMembers = () => api.get('/admin/members');
// export const adminUpdateMemberStatus = (id, status) => api.put(`/admin/members/${id}/status`, { status });
// export const adminRenewMember = (id) => api.put(`/admin/members/${id}/renew`);
// export const adminGetCases = () => api.get('/admin/cases');
// export const adminUpdateCaseStatus = (id, data) => api.put(`/admin/cases/${id}/status`, data);
// export const adminGetContent = () => api.get('/admin/content');
// export const adminCreateContent = (data) => api.post('/admin/content', data);
// export const adminUpdateContent = (id, data) => api.put(`/admin/content/${id}`, data);
// export const adminDeleteContent = (id) => api.delete(`/admin/content/${id}`);
// export const adminGetMessages = () => api.get('/admin/messages');
// export const adminReplyToMember = (memberId, content) => api.post('/admin/messages/reply', { memberId, content });
// export const adminGetAppointments = () => api.get('/admin/appointments');
// export const adminUpdateAppointmentStatus = (id, status) => api.put(`/admin/appointments/${id}/status`, { status });
// export const adminGetComplaints = () => api.get('/admin/complaints');
// export const adminUpdateComplaintStatus = (id, status) => api.put(`/admin/complaints/${id}/status`, { status });
// export const adminGetVolunteers = () => api.get('/admin/volunteers');
// export const adminUpdateVolunteerStatus = (id, status) => api.put(`/admin/volunteers/${id}/status`, { status });
// export const adminGetContactMessages = () => api.get('/admin/contact-messages');

// export default api;


import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8080/api';

const api = axios.create({
  baseURL: API_BASE_URL,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('sow_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      localStorage.removeItem('sow_token');
      localStorage.removeItem('sow_user');
      if (window.location.pathname.startsWith('/member') || window.location.pathname.startsWith('/admin')) {
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

// ---- Auth ----
export const registerMember = (data) => api.post('/auth/register', data);
export const registerAdmin = (data) => api.post('/auth/register-admin', data);
export const loginUser = (data) => api.post('/auth/login', data);
export const forgotPassword = (email) => api.post('/auth/forgot-password', { email });
export const resetPassword = (token, newPassword) => api.post('/auth/reset-password', { token, newPassword });

// ---- Member ----
export const getMyProfile = () => api.get('/member/profile');
export const getMyCases = () => api.get('/member/cases');
export const getCaseTimeline = (caseId) => api.get(`/member/cases/${caseId}/timeline`);
export const createCase = (data) => api.post('/cases', data);
export const getMyDocuments = () => api.get('/member/documents');
export const uploadDocument = (formData) =>
  api.post('/member/documents/upload', formData, { headers: { 'Content-Type': 'multipart/form-data' } });
export const getMyMessages = () => api.get('/member/messages');
export const sendMessage = (content) => api.post('/member/messages', { content });
export const getMyAppointments = () => api.get('/member/appointments');
export const bookAppointment = (data) => api.post('/member/appointments', data);
export const getMyReferrals = () => api.get('/member/referrals');

// ---- Public ----
export const getPublicStats = () => api.get('/public/stats');
export const getContentByCategory = (category) => api.get(`/public/content/${category}`);
export const getMembershipPackages = () => api.get('/public/membership-packages');
export const applyAsVolunteer = (data) => api.post('/public/volunteer', data);
export const submitEmployerComplaint = (data) => api.post('/public/employer-complaint', data);
export const submitContactMessage = (data) => api.post('/public/contact', data);

// ---- Admin ----
export const adminGetMembers = () => api.get('/admin/members');
export const adminUpdateMemberStatus = (id, status) => api.put(`/admin/members/${id}/status`, { status });
export const adminRenewMember = (id) => api.put(`/admin/members/${id}/renew`);
export const adminGetCases = () => api.get('/admin/cases');
export const adminUpdateCaseStatus = (id, data) => api.put(`/admin/cases/${id}/status`, data);
export const adminGetContent = () => api.get('/admin/content');
export const adminCreateContent = (data) => api.post('/admin/content', data);
export const adminUpdateContent = (id, data) => api.put(`/admin/content/${id}`, data);
export const adminDeleteContent = (id) => api.delete(`/admin/content/${id}`);
export const adminGetMessages = () => api.get('/admin/messages');
export const adminReplyToMember = (memberId, content) => api.post(`/admin/messages/${memberId}/reply`, { content });
export const adminGetAppointments = () => api.get('/admin/appointments');
export const adminUpdateAppointmentStatus = (id, status) => api.put(`/admin/appointments/${id}/status`, { status });
export const adminGetComplaints = () => api.get('/admin/complaints');
export const adminUpdateComplaintStatus = (id, status) => api.put(`/admin/complaints/${id}/status`, { status });
export const adminGetVolunteers = () => api.get('/admin/volunteers');
export const adminUpdateVolunteerStatus = (id, status) => api.put(`/admin/volunteers/${id}/status`, { status });
export const adminGetContactMessages = () => api.get('/admin/contact-messages');
export const adminGetDocuments = () => api.get('/admin/documents');
export const adminUploadDocument = (memberId, formData) =>
  api.post(`/admin/documents/${memberId}/upload`, formData, { headers: { 'Content-Type': 'multipart/form-data' } });
export const adminDownloadDocument = (id) => api.get(`/admin/documents/${id}/download`, { responseType: 'blob' });

export default api;
